// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"7fb9dbf9","453":"e2a347bd"}[chunkId] + ".chunk.js";
};